import React, { Component } from "react";
import { Grid, Cell } from "react-mdl";
import logo3 from "../Components/logo3.jpg";
import Animation from "../Components/animation";

class About extends Component {
  render() {
    return (
      <div className="contact-body">
        <Animation />
        <Grid className="contact-grid">
          <Cell col={6}>
            <h2>Hicham Fatih</h2>
            <img
              src={logo3}
              alt="logo2"
              style={{ height: "260px", width: "auto" }}
            />
          </Cell>
          <Cell col={6}>
            <h2>About Me</h2>
            <p style={{ width: "75%", margin: "auto", paddingTop: "1em" }}>
              Développeur Web Full Stack utilisant React js,Node js,Wordpress
              avec un accent sur le développement Web Frontend avec le Testing
              utilisant Selenium. Expérimenté dans la création d'applications
              CRUD, d'API RESTful utilisant Node.js avec l'élaboration des
              Rapport des Tests pendant le cycle de vie du développement de
              l'application . Bibliothèques courantes d'utilisation : Redux,
              react-router , Gsap, Materiel Designe . Utilisation courante des
              bibliothèques d'interface utilisateur: Bootstrap 4,
              React-Bootstrap, MaterialiseCSS, Material-UI .
            </p>
          </Cell>
        </Grid>
      </div>
    );
  }
}
export default About;
